// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

/* eslint-disable import/no-anonymous-default-export */
import CreditBureauReportActionTypes from './credit-bureau-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getCreditBureauReportListResponse: null,
	getCreditBureauReportListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FETCH CREDIT BUREAU REPORT START *********************** */
		case CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_SUCCESS:
			return {
				...state,
				getCreditBureauReportListResponse: action.payload,
				getCreditBureauReportListArr: docodeHexResponse(
					action.payload,
					'CreditCheckDetailsReportKey',
				),
			};

		case CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_FAILURE:
			return { ...state, getCreditBureauReportListResponse: action.payload };

		case CreditBureauReportActionTypes.GET_CREDIT_BUREAU_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getCreditBureauReportListResponse: null };
		/** ***************** FETCH CREDIT BUREAU REPORT END *********************** */
		default:
			return state;
	}
};
